import { Outlet } from 'react-router-dom'
import { APP_NAME } from '@/constants/app'
import { AuthBrandHeader, AuthBrandMark } from '@/modules/auth/components/auth-ui'

export function AuthLayout() {
  return (
    <div className="grid min-h-svh bg-background lg:grid-cols-[minmax(0,1.1fr)_minmax(0,0.9fr)]">
      <aside className="auth-brand relative hidden items-center justify-center overflow-hidden px-10 py-12 lg:flex">
        <div className="auth-brand-grid absolute inset-0" aria-hidden />
        <div className="auth-brand-glow absolute inset-0" aria-hidden />
        <div className="relative z-10 mx-auto max-w-md text-center">
          <AuthBrandMark size="lg" />
          <p className="auth-display mt-6 text-4xl font-bold tracking-tight text-white">
            {APP_NAME}
          </p>
        </div>
      </aside>

      <div className="auth-form-mesh flex min-h-svh flex-col lg:min-h-0">
        <div className="auth-brand relative shrink-0 px-4 pb-5 pt-[max(1.25rem,env(safe-area-inset-top))] lg:hidden">
          <div className="auth-brand-grid absolute inset-0" aria-hidden />
          <div className="auth-brand-glow absolute inset-0" aria-hidden />
          <div className="relative z-10">
            <AuthBrandHeader size="sm" />
          </div>
        </div>

        <main className="flex flex-1 flex-col justify-start px-4 pb-[max(1rem,env(safe-area-inset-bottom))] pt-1 sm:px-6 lg:justify-center lg:px-8 lg:py-8">
          <div className="mx-auto w-full max-w-md flex-1 lg:flex-none">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  )
}
